module.exports = __webpack_public_path__ + "img/snorkeling-7.2ff7eef5.jpeg";